<template>
  <div class="stuff-page">
    <div class="order_nav">
      <nav-bar
        @goBack="goBack"
        :bgTrans="true"
        :titleText="pageTitle"
        :lefticonshow="true"
        :TextColor="titStyle"
        :lefticon="lefticon"
        :righticonshow="true"
        :righticon="righticon"
        @rightclick="changeIcon"
      >
      </nav-bar>
    </div>
    <div class="stuff-List">
      <img
        src="@/assets/third/secondary/secondary_bg2.png"
        class="stuff_top"
        alt=""
      />
      <div class="stuff-box">
        <div class="stuff-box1">
          <van-pull-refresh
            v-model="isLoading"
            @refresh="onRefresh"
            v-if="goodsList"
          >
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="别拉了，小巴也是有底线的"
              @load="onLoad"
            >
              <van-row class="supermarket-like" v-if="!showVertical">
                <div
                  class="item-box"
                  v-for="(item, index) in goodsList"
                  :key="index"
                  @click.stop="goDetailBS(item.id)"
                >
                  <div class="item-img">
                    <img
                      class="imgPro"
                      :src="item.thumb"
                      @error="defaultPro()"
                    />
                    <img
                      src="@/assets/third/secondary/secondary_icon41x19.png"
                      alt=""
                    />
                  </div>
                  <div class="item-info">
                    <div class="name">{{ item.name }}</div>
                    <div class="desc"></div>
                    <div class="item-desc">
                      <img v-if="item.label" :src="item.label.image" alt="" />
                    </div>
                    <div class="item-price">
                      <div class="item-rig">
                        <div class="i-price">
                          <span>¥{{ item.activity_min_price }}</span
                          ><s>¥{{ item.strikeout_price }}</s>
                        </div>
                        <div class="buyIt">立即抢购</div>
                      </div>
                    </div>
                  </div>
                </div>
              </van-row>
              <van-row class="supermarket-like item-vertical" v-else>
                <van-col span="12">
                  <div
                    class="item-box"
                    v-for="(item, index) in even(goodsList)"
                    :key="index"
                    @click.stop="goDetailBS(item.id)"
                  >
                    <div class="item-img">
                      <img
                        class="imgPro"
                        :src="item.thumb"
                        @error="defaultPro()"
                      />
                      <img
                        src="@/assets/third/secondary/secondary_icon41x19.png"
                        alt=""
                      />
                    </div>
                    <div class="item-info">
                      <div class="name">
                        <img v-if="item.label" :src="item.label.image" alt="" />
                        {{ item.name }}
                      </div>
                      <div class="desc"></div>
                      <div class="item-price">
                        <div class="item-rig">
                          <div class="i-price">
                            <span>¥{{ item.activity_min_price }}</span
                            ><s>¥{{ item.strikeout_price }}</s>
                          </div>
                          <div class="buyIt">立即抢购</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </van-col>
                <van-col span="12">
                  <div
                    class="item-box"
                    v-for="(item, index) in ogg(goodsList)"
                    :key="index"
                    @click.stop="goDetailBS(item.id)"
                  >
                    <div class="item-img">
                      <img
                        class="imgPro"
                        :src="item.thumb"
                        @error="defaultPro()"
                      />
                      <img
                        src="@/assets/third/secondary/secondary_icon41x19.png"
                        alt=""
                      />
                    </div>
                    <div class="item-info">
                      <div class="name">
                        <img v-if="item.label" :src="item.label.image" alt="" />
                        {{ item.name }}
                      </div>
                      <div class="desc"></div>
                      <div class="item-price">
                        <div class="item-rig">
                          <div class="i-price">
                            <span>¥{{ item.activity_min_price }}</span
                            ><s>¥{{ item.strikeout_price }}</s>
                          </div>
                          <div class="buyIt">立即抢购</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </van-col>
              </van-row>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import navBar from "../components/navBar";
export default {
  data() {
    return {
      crossicon: require("@/assets/third/secondary/cross_icon.png"),
      lefticon: require("@/assets/third/secondary/secondary_back2.png"),
      verticalIcon: require("@/assets/third/secondary/vertical_icon.png"),
      righticon: "",
      titStyle: "#fff",
      goodsList: [],
      goodsId: "",
      shopId: "",
      loading: false,
      finished: false,
      isLoading: false,
      page: 0,
      pageSize: 10,
      allList: 11,
      showVertical: false,
      sort_rule: "",
      area_id: "",
      pageTitle: "",
    };
  },
  components: {
    navBar,
  },
  created() {
    this.righticon = this.crossicon;
    let area_id = this.$route.query.id;
    let sort_rule = this.$route.query.sort_rule;
    this.pageTitle = this.$route.query.pageTitle;
    if (area_id) {
      this.area_id = area_id;
    }
    if (sort_rule) {
      this.sort_rule = sort_rule;
    }
  },
  methods: {
    even(list) {
      return list.filter((l, s) => {
        return s % 2 === 0;
      });
    },
    ogg(list) {
      return list.filter((l, s) => {
        return s % 2 != 0;
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    changeIcon() {
      // item-vertical
      this.showVertical = !this.showVertical;
      this.righticon = this.showVertical ? this.verticalIcon : this.crossicon;
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getGoodsList();
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.goodsList = [];
      this.getGoodsList();
    },
    goDetailBS(id) {
      //商品详情
      let params = {
        goodsId: id,
        shopId: 8,
      };
      this.params(JSON.stringify(params), JSON.stringify(params), "goDetailBS");
    },
    getGoodsList() {
      this.$api
        .post("ongoods/index/goods/area-list", {
          area_id: this.area_id,
          sort_rule: this.sort_rule,
          page: this.page,
        })
        .then((res) => {
          this.allList = res.total;
          if (res.list.length > 0) {
            res.list.forEach((item, i) => {
              this.goodsList.push(item);
            });
          }
          this.loading = false;

          if (this.goodsList.length >= this.allList) {
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.finished = true;
          if (err.message) {
            this.$toast(err.message);
          }
        });
    },
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
    window.onresize = () => {
      document.documentElement.style.setProperty(
        "font-size",
        (document.body.clientWidth / 375) * 10 + "px"
      );
    };
  },
};
</script>
<style lang="less" scoped>
.stuff-page {
  min-height: 100%;
  background: #f5f6f7;
}
.order_nav {
  position: fixed;
  width: 100%;
  // z-index: 99999;
}
.stuff-List {
  height: 100%;
  .stuff-box {
    width: 100%;
    top: 8.5rem;
    position: fixed;
    height: calc(100% - 8.5rem);
    z-index: 99999999;
    .stuff-box1 {
      overflow-y: scroll;
      background: #f5f6f7;
      height: calc(100%);
    }
  }
}
.stuff_top {
  z-index: 99999;
  width: 100%;
}
.supermarket-like {
  padding-top: 1rem;
  background: #f5f6f7;
}
.item-vertical {
  & > div:nth-of-type(2) > div {
    margin: 0 1rem 1rem 0.5rem;
  }
  .item-box {
    display: inline-block;
    width: 17.25rem;
    margin: 0 0.5rem 1rem 1rem;
    background: #fff;
    padding: 0;
    border-radius: 1rem;
    .item-price {
      .item-rig {
        width: 17.7rem;
        height: 2.9rem;
        background: url("~@/assets/third/secondary/secondary_icon155x29.png")
          no-repeat;
        background-size: 100% 100%;
        padding: 0 0.2rem 0 0.6rem;
        display: flex;
      }
      .buyIt {
        font-size: 1.2rem;
        transform: scale(0.9);
        min-width: 4.5rem;
        overflow: hidden;
      }
      .i-price {
        flex: 1;
        display: flex;
        overflow: hidden;
      }
      .i-price > span {
        font-size: 1.2rem;
      }
    }
    .item-info {
      padding: 0 1rem 1rem 1rem;
      .name {
        width: 100%;
        -webkit-line-clamp: 2;
        max-height: 4rem;
        min-height: auto;
        line-height: 1.9rem;
        font-size: 1.3rem;
      }
    }
    .desc {
      margin: 0.3rem 0 0.9rem 0;
    }
    .item-desc {
      margin-bottom: 0.9rem;
      margin-top: 0;
    }
    .item-img {
      width: 17.25rem;
      height: 17.25rem;
      position: relative;
      border-radius: 0.6rem 0.6rem 0rem 0rem;
      & > img:nth-of-type(1) {
        width: 100%;
        height: 100%;
      }
      & > img:nth-of-type(2) {
        position: absolute;
        top: 0;
        left: 0;
        width: 5.2rem;
        height: 2.4rem;
      }
    }
  }
}
.item-box {
  margin: 0 1rem 1.2rem 1rem;
  display: flex;
  background: #fff;
  padding: 1rem;
  border-radius: 1rem;
  .desc {
    color: #999999;
    font-size: 1.2rem;
    max-height: 2rem;
    line-height: 2rem;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  .item-info {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    .name {
      width: 20.5rem;
      font-size: 1.4rem;
      color: #333333;
      padding: 0.4rem 0 0 0;
      max-height: 4rem;
      line-height: 2rem;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    img {
      width: auto;
      height: 1.5rem;
      margin: 0 0.3rem 0 0;
      position: relative;
      display: inline-block;
      top: 0.3rem;
    }
  }
  .type_icon1 {
    color: #fff;
    display: inline-block;
    background: #4534c8;
    border-radius: 0.2rem;
    font-size: 1rem;
    width: 3.3rem;
    height: 1.8rem;
    line-height: 1.8rem;
    // transform: scale(0.8);
    text-align: center;
    margin-left: -0.15rem;
  }
  .item-price {
    display: flex;
    justify-content:flex-end;
    .item-rig {
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 0.8rem;
      width: 15.8rem;
      height: 3rem;
      background: url("~@/assets/third/secondary/secondary_icon174x32.png")
        no-repeat;
      background-size: 100% 100%;
      .i-price {
        height: 100%;
        display: flex;
        align-items: center;
      }
    }
    .buyIt {
      font-size: 1.3rem;
      color: #fff;
      line-height: 3rem;
    }
  }
  .item-desc {
    flex: 1;
    margin-top: 0.5rem;
    display: flex;
    & > span {
      color: #fff;
      background: #4534c8;
      font-size: 1rem;
      // transform: scale(0.9);
      display: inline-block;
    }
  }
  .i-price {
    width: 10rem;
    overflow: hidden;
    & > span {
      color: #fa553d;
      font-size: 1.3rem;
      font-weight: 600;
    }
    & > s {
      color: #999999;
      font-size: 1.2rem;
      transform: scale(0.85);
      display: inline-block;
    }
  }
}
.item-img {
  width: 12rem;
  height: 12rem;
  margin-right: 1rem;
  position: relative;
  border-radius: 0.6rem;
  overflow: hidden;
  & > img:nth-of-type(1) {
    width: 100%;
    height: 100%;
  }
  & > img:nth-of-type(2) {
    position: absolute;
    top: 0;
    left: 0;
    width: 4.6rem;
    height: 2.1rem;
  }
}
</style>